import { Scale } from '@ritabygglov/core';

export const CORNER_OFFSET = 8;
export const CONNECTING_BORDER_SIZE = 8;
export const CONNECTING_BORDER_STYLE = 'butt';
export const CONNECTING_BORDER_OPACITY = 0.1;
export const CONNECTING_BORDER_STROKE = 'gray';
/** Single source is --active-blue in index.css. */
export const COLOR_HANDLE = 'var(--active-blue)';
export const COLOR_GHOST_LINE = '#7FB2F0';
/** viewBox units per screen pixel at the default view. Larger = zoomed out. */
export const BASE_VIEW_SCALE = 1.75;
/** Most zoomed in: 25x the default view. */
export const MIN_VIEW_SCALE = BASE_VIEW_SCALE / 25;
/** Most zoomed out: 50% of the default view. */
export const MAX_VIEW_SCALE = BASE_VIEW_SCALE * 2;
export const STROKE_WIDTH = 4;
export const CONNECTING_POINT_RADIUS = 10;
// Weight of each drawn face line of an outlined wall; the white inner line fills
// what is left of the thickness between them.
export const WALL_LINE_WEIGHT = 1;
// Crossing ticks on a dimension line are decoration, not a wall.
export const DIMENSION_TICK_STROKE_WIDTH = 0.5;
export const TEXT_MIN_WIDTH = 40;
export const TEXT_MIN_HEIGHT = 24;

export const SCALE_OPTIONS: Scale[] = [
  '1:1000',
  '1:800',
  '1:500',
  '1:400',
  '1:250',
  '1:200',
  '1:100',
  '1:50',
];
export const DEFAULT_SCALE = SCALE_OPTIONS[1];
export const INTERNATIONAL_FORMAT_OPTIONS = [
  'A3_LANDSCAPE',
  'A3_PORTRAIT',
  'A4_LANDSCAPE',
  'A4_PORTRAIT',
];
export const US_FORMAT_OPTIONS = [
  'LETTER_LANDSCAPE',
  'LETTER_PORTRAIT',
  'TABLOID_LANDSCAPE',
  'TABLOID_PORTRAIT',
  'ARCH_C_LANDSCAPE',
  'ARCH_C_PORTRAIT',
  'ARCH_D_LANDSCAPE',
  'ARCH_D_PORTRAIT',
];
export const FORMAT_OPTIONS = [
  ...INTERNATIONAL_FORMAT_OPTIONS,
  ...US_FORMAT_OPTIONS,
];
export const PRETTY_FORMAT_OPTIONS = {
  [FORMAT_OPTIONS[0]]: 'A3 Liggande',
  [FORMAT_OPTIONS[1]]: 'A3 Stående',
  [FORMAT_OPTIONS[2]]: 'A4 Liggande',
  [FORMAT_OPTIONS[3]]: 'A4 Stående',
};
export const DEFAULT_FORMAT = FORMAT_OPTIONS[0];
